import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { PollEventPage } from './poll-event';
import { PollEventComponentsModule } from './components/poll-events-components.module';

@NgModule({
  declarations: [
    PollEventPage,
  ],
  exports:[
    PollEventPage
  ],
  imports: [
    IonicPageModule.forChild(PollEventPage),
    PollEventComponentsModule
  ],
})
export class PollEventPageModule {}



// WEBPACK FOOTER //
// ./src/pages/poll-event/poll-event.module.ts